import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import { t } from '../../localization.js';
import HiddenStatisticsIcon from '../HiddenStatisticsIcon/HiddenStatisticsIcon.js';
import MemberName from '../MemberName/MemberName.js';
import styles from './ClanMember.module.scss.js';

var ClanMember = (function (_super) {
    __extends(ClanMember, _super);
    function ClanMember() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClanMember.prototype.render = function () {
        var _a, _b;
        var role = this.props.role ? React.createElement("div", { className: styles.memberRole }, t(this.props.role)) : null;
        var hiddenStatisticsIcon = this.props.isOwn && this.props.isHiddenStatistics ? (React.createElement("div", { className: styles.hiddenStatisticsIcon },
            React.createElement(HiddenStatisticsIcon, { isOwnAccount: true }))) : null;
        var classNameMember = classNames(styles.member, (_a = {},
            _a[styles.isOwn] = this.props.isOwn,
            _a[styles.isHiddenStatistics] = this.props.isOwn && this.props.isHiddenStatistics,
            _a));
        var classNameMemberName = classNames(styles.memberName, (_b = {},
            _b[styles.isHighlightedAdmittance] = this.props.isHighlightedAdmittance,
            _b));
        return (React.createElement("div", { className: classNames(classNameMember, this.props.className), onContextMenu: this.props.onContextMenu },
            hiddenStatisticsIcon,
            React.createElement("div", { className: classNameMemberName },
                React.createElement(MemberName, { name: this.props.name, isInline: true })),
            role));
    };
    return ClanMember;
}(React.PureComponent));

export { ClanMember as default };
//# sourceMappingURL=ClanMember.js.map
